import React, { useState, useEffect, memo } from 'react';
import json from '../../Auditoria/index.json';
import { Objeto } from '../../../../Services/Models';
import { L10n, loadCldr, setCulture, setCurrencyCode } from '@syncfusion/ej2-base';
import { PdfHeaderQueryCellInfoEventArgs, PdfQueryCellInfoEventArgs } from '@syncfusion/ej2-react-grids'
import { Button, Card, FormGroup, Elevation, H2, InputGroup, Icon, MenuItem, ButtonGroup } from '@blueprintjs/core';
import { Select, MultiSelect } from "@blueprintjs/select";
import moment from 'moment';
import {
  ColumnDirective,
  ColumnsDirective,
  AggregateColumnDirective,
  AggregateColumnsDirective,
  AggregateDirective,
  AggregatesDirective,
  Aggregate,
  GridComponent,
  Page,
  Inject,
  Filter,
  Group,
  ExcelExport,
  PdfExport,
  Toolbar,
  ToolbarItems,
  Grid,
  FilterSettingsModel,
  Sort,
  Resize
} from '@syncfusion/ej2-react-grids';
import './style.css'
import { Identificador } from '../../../../Services/Controllers';

L10n.load(json)
loadCldr(
  require('../../../../../node_modules/cldr-data/main/pt/currencies.json'),
  require('../../../../../node_modules/cldr-data/main/pt/numbers.json'),
  require('../../../../../node_modules/cldr-data/main/pt/numbers.json'),
  require('../../../../../node_modules/cldr-data/main/pt/ca-gregorian.json'),
  require('../../../../../node_modules/cldr-data/main/pt/timeZoneNames.json'),
  require('../../../../../node_modules/cldr-data/supplemental/numberingSystems.json'));
setCulture('pt');
setCurrencyCode("BRL");

function App({ dados }: any) {
  const [getData, setData] = useState<Array<Objeto.VendaNoTempo>>([]);
  let preTotalValue: number = 0;
  let preData: Array<Objeto.VendaNoTempo> = [];
  const filterOptions: FilterSettingsModel = {
    ignoreAccent: true,
    immediateModeDelay: 200,
    mode: "Immediate",
    type: 'Excel'
  }
  let grid: Grid | null;
  const toolbarOptions: ToolbarItems[] = ['PdfExport', 'CsvExport']
  const pdfQueryCellInfo = (args: PdfQueryCellInfoEventArgs | any) => {
    args.cell.cellHeight = 10;
  }
  const pdfHeaderQueryCellInfo = (args: PdfHeaderQueryCellInfoEventArgs | any) => {
    (args.cell as any).row.pdfGrid.repeatHeader = true;
    args.cell.gridRow.pdfGrid.columns.getColumn(0).width = 200;
    args.cell.gridRow.pdfGrid.columns.getColumn(2).textAlign = "Right";
  }
  const toolbarClick = (args: any) => {
    console.log('pre-grid')
    if (grid) {
      console.log(args.item.id)
      if (args.item.id === 'grid_pdfexport') {
        grid.pdfExport({
          fileName: `Vendas No Tempo ${moment(new Date(), true).format("YYYY-MM-DD")}.pdf`,
          pageOrientation: "Landscape",
          header: {
            fromTop: 0,
            height: 130,
            contents: [
              {
                type: 'Text',
                value: `${moment(new Date(), true).format("DD/MM/YYYY HH:mm:ss")}`,
                position: { x: 880, y: 55 },
                style: { textBrushColor: "#000000", fontSize: 13 },
              },
            ]
          },
          footer: {
            contents: [
              {
                type: 'Text',
                value: `Powered by DigitalDEV`,
                position: { x: 0, y: 55 },
                style: { textBrushColor: "#000000", fontSize: 10 },
              },
              {
                format: 'Página {$current} de {$total}',
                pageNumberType: "Numeric",
                position: { x: 910, y: 50 },
                style: {
                  fontSize: 13,
                  hAlign: "Right",
                  textBrushColor: '#000000',
                },
                type: 'PageNumber',
              }
            ],
            fromBottom: 0,
            height: 100,
          },
          theme: {
            header: {
              bold: true,
              fontColor: "#000000",
              fontSize: 8,
              // font: new PdfTrueTypeFont(adventProFont, 7, PdfFontStyle.Bold)
            },
            record: {
              bold: false,
              fontColor: "#000000",
              fontSize: 8,
              // font: new PdfTrueTypeFont(adventProFont, 7)
            },
            caption: {
              bold: true,
              fontColor: "#000000",
              fontSize: 8,
              // font: new PdfTrueTypeFont(adventProFont, 7, PdfFontStyle.Bold)
            }
          },
          allowHorizontalOverflow: false,

        });
      }
      if (args.item.id === 'grid_excelexport') {
        grid.excelExport({
          dataSource: getData
        })
      }
      if (args.item.id === 'grid_csvexport') {
        grid.getColumnByField('APagar').format = "N2"
        grid.getColumnByField('Pago').format = "N2"
        grid.getColumnByField('ValorUnitItem_Des').format = "N2"
        grid.getColumnByField('ContratoServ_Des').format = "N2"
        grid.getColumnByField('CodMedicao_Des').format = "N2"
        grid.getColumnByField('Valor_vi').format = "N2"
        grid.csvExport({
          dataSource: getData
        })
      }
    }
  }

  useEffect(() => {
    dados && dados.forEach((dado:any) => {
      dado.Data_vi = dado.Data_vi ? moment(dado.Data_vi, "YYYY-MM-DD").format("DD/MM/YYYY") : dado.Data_vi;
      dado.DtPgto_Des = dado.DtPgto_Des ? moment(dado.DtPgto_Des, "YYYY-MM-DD").format("DD/MM/YYYY") : dado.DtPgto_Des;
      dado.DtDocFisc_Proc = dado.DtDocFisc_Proc ? moment(dado.DtDocFisc_Proc, "YYYY-MM-DD").format("DD/MM/YYYY") : dado.DtDocFisc_Proc;
      dado.Proc_Parc = `${dado.NProcesso}/${dado.NParcela}`
    })
    setData(dados)
  }, [dados])

  return (
    <>
      <div style={{ maxWidth: '100%' }}>
        <GridComponent
          dataSource={getData}
          id='grid'
          allowSorting={true}
          allowMultiSorting={true}
          ref={g => grid = g}
          allowPaging={true}
          allowFiltering={true}
          pageSettings={{ pageSizes: [10, 20, 30], pageSize: 15 }}
          filterSettings={filterOptions}
          toolbarClick={toolbarClick}
          toolbar={toolbarOptions}
          pdfQueryCellInfo={pdfQueryCellInfo}
          pdfHeaderQueryCellInfo={pdfHeaderQueryCellInfo}
          actionBegin={
            (args: any) => {
              if (args.requestType === "filterchoicerequest" || args.requestType === 'filtersearchbegin') {
                args.filterChoiceCount = 1000000;
              }
            }
          }
          allowPdfExport={true}
          allowResizing={true}
          allowExcelExport={true}>
          <ColumnsDirective>
            <ColumnDirective field="DescEmp_Des" headerText="DescEmp_Des" width='155px' />
            <ColumnDirective field="DescObra_Des" headerText="DescObra_Des" width='200px' />
            <ColumnDirective field='DescProdPl_Des' headerText='DescProdPl_Des' width='182px' />
            <ColumnDirective field='DescCompPl_Des' headerText='DescCompPl_Des' width='180px' />
            <ColumnDirective field='ItemPl_Des' headerText='Item' width='190px' />
            <ColumnDirective field='Servico' headerText='Servico' width='190px' />
            <ColumnDirective field='DescInsPl_Des' headerText='DescInsPl_Des' width='200px' />
            <ColumnDirective field='DtPgto_Des' headerText='DtPgto_Des' width='200px' />
            <ColumnDirective field='DescForn_Des' headerText='DescForn_Des' width='180px' />
            <ColumnDirective field='NProcesso' headerText='NProcesso' width='180px' />
            <ColumnDirective field='NParcela' headerText='NParcela' width='180px' />
            <ColumnDirective field='APagar' headerText='APagar' format="C2" width='180px' />
            <ColumnDirective field='Pago' headerText='Pago' format="C2" width='180px' />
            <ColumnDirective field='DescrItemPai' headerText='DescrItemPai' width='180px' />
            <ColumnDirective field='Banco_Des' headerText='Banco_Des' width='180px' />
            <ColumnDirective field='ContaCorr_Des' headerText='ContaCorr_Des' width='200px' />
            <ColumnDirective field='InsumoComprado' headerText='InsumoComprado' width='200px' />
            <ColumnDirective field='DescForn_Des' headerText='Fornecedor' width='200px' />
            <ColumnDirective field='cpf_pes' headerText='CPF/CNPJ' width='180px' />
            <ColumnDirective field='DocFiscal_Des' headerText='Documento Fiscal' width='200px' />
            <ColumnDirective field='DtDocFisc_Proc' headerText='Data de Emissão' width='200px' />
            <ColumnDirective field='ItemProc_Des' headerText='ItemProc_Des' width='200px' />
            <ColumnDirective field='QtdeItem_Des' headerText='QtdeItem_Des' format="N0" width='200px' />
            <ColumnDirective field='ValorUnitItem_Des' headerText='Valor unitário' format="C2" width='200px' />
            <ColumnDirective field='ContratoServ_Des' headerText='ContratoServ_Des' format="C2" width='200px' />
            <ColumnDirective field='CodMedicao_Des' headerText='CodMedicao_Des' format="C2" width='200px' />
            <ColumnDirective field='Idx_vi' headerText='Índice' width='200px' />
            <ColumnDirective field='Valor_vi' headerText='Valor índice' format="C2" width='180px' /> 
          </ColumnsDirective>
          <AggregatesDirective>
            <AggregateDirective>
              <AggregateColumnsDirective>
                <AggregateColumnDirective field="APagar" type="Sum" format="C2" footerTemplate={
                  (props: any) => <span>{props.Sum}</span>
                } />
                <AggregateColumnDirective field="Pago" type="Sum" format="C2" footerTemplate={
                  (props: any) => <span>{props.Sum}</span>
                } />
              </AggregateColumnsDirective>
            </AggregateDirective>
          </AggregatesDirective>
          <Inject services={[Page, Filter, Group, ExcelExport, PdfExport, ExcelExport, Toolbar, Aggregate, Sort, Resize]} />
        </GridComponent>
      </div>
    </>
  );
}

export default memo(App);